import { reaction } from "mobx";
import { useSyncExternalStore } from "react";

import { rootStore } from "@/store/RootStore";

const subscribe = (onChange: () => void) =>
  reaction(() => rootStore.currencyFilter.currency, onChange);

const getSnapshot = () => rootStore.currencyFilter.currency;

/**
 * The admin's selected currency, as a value that changes when the admin picks
 * another country. Put it in a query key so the data reloads when it changes.
 * (`withAdminCurrency` is what puts it on the call itself.)
 */
export const useAdminCurrency = (): string =>
  useSyncExternalStore(subscribe, getSnapshot);
